import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconFilterSvg } from "./IconFilterSvg.mjs";
const IconFilter = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconFilterSvg, ...iconProps });
};
export {
  IconFilter
};
